import { amountToDisplayValue } from '@billy/design-system'
import { Typography } from '@shinetools/lumen-react'
import { colors } from '@shinetools/lumen-tokens/web/colors'
import { ReactElement } from 'react'

import { EMPTY_VALUE_PLACEHOLDER } from '../../../../constants/emptyValuePlaceholder'

interface ProfitAndLossAmountProps {
  bold?: boolean
  value?: number
}

export const ProfitAndLossAmount = ({ bold = false, value }: ProfitAndLossAmountProps): ReactElement => {
  const isZero = value === undefined || value === 0

  return (
    <Typography.Text
      color={!isZero && value < 0 ? colors.content.danger.bold : undefined}
      weight={bold ? 'semibold' : 'regular'}
    >
      {isZero ? EMPTY_VALUE_PLACEHOLDER : amountToDisplayValue(value)}
    </Typography.Text>
  )
}
